var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 2.75H10.2503L7.64969 0.8C7.38967 0.605989 7.07411 0.500805 6.74969 0.5H1.75C1.35218 0.5 0.970644 0.658035 0.68934 0.93934C0.408035 1.22064 0.25 1.60218 0.25 2V14.75C0.25 15.1478 0.408035 15.5294 0.68934 15.8107C0.970644 16.092 1.35218 16.25 1.75 16.25H18.3334C18.709 16.2495 19.069 16.1001 19.3346 15.8346C19.6001 15.569 19.7495 15.209 19.75 14.8334V4.25C19.75 3.85218 19.592 3.47064 19.3107 3.18934C19.0294 2.90804 18.6478 2.75 18.25 2.75ZM18.25 14.75H1.75V2H6.74969L9.35031 3.95C9.61033 4.14401 9.92589 4.2492 10.2503 4.25H18.25V14.75Z",
    fill: "#ABB1BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.1e5de5dbf1b3329053dfce94882ad841.svg";
export { ForwardRef as ReactComponent };